import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from '../components/ui/select';
import { usePortalAuth } from './PortalAuthContext';
import { usePortalDestination } from './PortalDestinationContext';

const MANAGE = '__manage';

export const PortalPersonSwitcher = () => {
  const { patient, family, activeMemberId, setActiveMember } = usePortalAuth();
  const { href } = usePortalDestination();
  const navigate = useNavigate();
  if (!patient || family.length === 0) return null;
  const firstName = (patient.name || 'Me').split(' ')[0];
  return (
    <Select
      value={activeMemberId || 'self'}
      onValueChange={(value) => {
        if (value === MANAGE) { navigate(href('family')); return; }
        setActiveMember(value === 'self' ? '' : value);
      }}
    >
      <SelectTrigger
        className="h-9 w-10 justify-center px-0 sm:w-44 sm:justify-between sm:px-3 text-sm [&>svg:last-of-type]:hidden sm:[&>svg:last-of-type]:block [&>span]:hidden sm:[&>span]:block"
        aria-label="Switch person" data-testid="portal-person-switcher">
        <Users className="w-4 h-4 shrink-0 opacity-70 sm:mr-1.5" />
        <span className="truncate"><SelectValue /></span>
      </SelectTrigger>
      <SelectContent data-testid="portal-person-options">
        <SelectItem value="self" data-testid="portal-person-self">{firstName} (me)</SelectItem>
        {family.map((member) => (
          <SelectItem key={member.patient_user_id} value={member.patient_user_id}
            data-testid={`portal-person-${member.patient_user_id}`}>{member.name}</SelectItem>
        ))}
        <SelectSeparator />
        <SelectItem value={MANAGE} data-testid="portal-person-manage">Manage family…</SelectItem>
      </SelectContent>
    </Select>
  );
};
